import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './subscriptionModel';
import { RootStoreType } from '../rootReducer';

const statesSlice = createSlice({
    name: 'subscriptionReducer',
    initialState: initialState.subscriptionModel,
    reducers: {
        setIsSubscriptionDialogOpen: (state, action: PayloadAction<boolean>) => {
            state.isSubscriptionDialogOpen = action.payload;
        },
        setIsManageSubscriptionDialogOpen: (state, action: PayloadAction<boolean>) => {
            state.isManageSubscriptionDialogOpen = action.payload;
        },
        setIsChangeSubscriptionDialogOpen: (state, action: PayloadAction<boolean>) => {
            state.isChangeSubscriptionDialogOpen = action.payload;
        }
    }
});

export const {
    setIsSubscriptionDialogOpen,
    setIsManageSubscriptionDialogOpen,
    setIsChangeSubscriptionDialogOpen
} = statesSlice.actions;

//selectors
export const getIsSubscriptionDialogOpen = (store: RootStoreType): boolean => store.subscription.subscriptionModel.isSubscriptionDialogOpen;
export const getIsManageSubscriptionDialogOpen = (store: RootStoreType): boolean => store.subscription.subscriptionModel.isManageSubscriptionDialogOpen;
export const getIsChangeSubscriptionDialogOpen = (store: RootStoreType): boolean => store.subscription.subscriptionModel.isChangeSubscriptionDialogOpen;

export default statesSlice.reducer;